import { render, staticRenderFns } from "./product-quantity.component.vue?vue&type=template&id=0996a712&"
import script from "./product-quantity.component.vue?vue&type=script&lang=js&"
export * from "./product-quantity.component.vue?vue&type=script&lang=js&"
import style0 from "./product-quantity.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports